import React, { Component } from "react";
import { connect } from "react-redux";
import {
retrieveDocuments,findDocumentsByTitle,deleteAllDocuments
} from "../actions/document";
import { Link } from "react-router-dom";

class DocumentsList extends Component {
  constructor(props) {
    super(props);
    this.onChangeSearchNom = this.onChangeSearchNom.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.setActiveDocument = this.setActiveDocument.bind(this);
    this.findByNom = this.findByNom.bind(this);
    this.removeAllDocuments = this.removeAllDocuments.bind(this);

    this.state = {
      currentDocument: null,
      currentIndex: -1,
      searchNom: "",
    };
  }

  componentDidMount() {
    this.props.retrieveDocuments();

  }

  onChangeSearchNom(e) {
    const searchNom = e.target.value;

    this.setState({
      searchNom: searchNom,
    });
  }

  refreshData() {
    this.setState({
      currentDocument: null,
      currentIndex: -1,
    });
  }

  setActiveDocument(theme, index) {
    this.setState({
      currentDocument: theme,
      currentIndex: index,
    });
  }

  removeAllDocuments() {
    this.props
      .deleteAllDocuments()
      .then((response) => {
        console.log(response);
        this.refreshData();
      })
      .catch((e) => {
        console.log(e);
      });
  }

  findByNom() {
    this.refreshData();

    this.props.findDocumentsByTitle(this.state.searchNom);
  }

  render() {
    const { searchNom, currentDocument, currentIndex } = this.state;
    const { documents } = this.props;


    return (
      <div className="list row">
        <div className="col-md-8">
          <div className="input-group mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Rechercher un document"
              value={searchNom}
              onChange={this.onChangeSearchNom}
            />

            <div className="input-group-append">
              <button
                className="btn btn-outline-secondary"
                type="button"
                onClick={this.findByNom}
              >
                Rechercher
              </button>

            </div>

          </div>
        </div>
        <div className="col-md-6">
          <h4>Liste des documents</h4>

          <ul className="list-group">

            {documents &&
            documents.map((document, index) => (

                  <li
                  className={
                    "list-group-item " +
                    (index === currentIndex ? "active" : "")
                  }

                  onClick={() => this.setActiveDocument(document)}
                  key={document.id}

                >
                    <ul> {document.Nom}      </ul>
                </li>


              ))}
          </ul>

          <button
            className="m-3 btn btn-sm btn-danger"
            onClick={this.removeAllDocuments}
          >
            Supprimer tous les documents
          </button>
        </div>
        <div className="col-md-6">
          {currentDocument ? (
            <div>
              <h4>Document</h4>
              <div>
                <label>
                  <strong>Nom:</strong>
                </label>{" "}
                {currentDocument.Nom}
              </div>
              <div>
                <label>
                  <strong>Status:</strong>
                </label>{" "}
                {currentDocument.published ? "Published" : "Pending"}
              </div>

              <Link
                to={"/documents/" + currentDocument.id}
                className="badge badge-warning"
              >
                Editer
              </Link>
            </div>
          ) : (
            <div>
              <br />
              <p>Cliquez sur un thème ou  </p>
              <p>  <a className="nav-item"
                            href="https://pointage.ansart-tp.com/adddocuments" type="button"> Ajouter un document </a>
              </p>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    documents: state.documents,
  };
};

export default connect(mapStateToProps, {
  retrieveDocuments,findDocumentsByTitle,deleteAllDocuments

})(DocumentsList);
